import { Plus, X } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function ContribList({ label, items, setItems, testIdPrefix }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <div className="space-y-2">
        {items.map((c, i) => (
          <div key={i} className="grid grid-cols-[1fr,1fr,auto] gap-2">
            <input
              data-testid={`${testIdPrefix}-name-${i}`}
              placeholder="Full name"
              className={inputCls}
              value={c.name}
              onChange={(e) => {
                const copy = [...items]; copy[i] = { ...copy[i], name: e.target.value }; setItems(copy);
              }}
            />
            <input
              data-testid={`${testIdPrefix}-role-${i}`}
              placeholder="Role (e.g. Vocals, Producer)"
              className={inputCls}
              value={c.role}
              onChange={(e) => {
                const copy = [...items]; copy[i] = { ...copy[i], role: e.target.value }; setItems(copy);
              }}
            />
            <button
              type="button"
              onClick={() => setItems(items.filter((_, j) => j !== i))}
              className="rounded-xl border border-white/10 hover:bg-red-500/10 hover:border-red-500/30 text-slate-400 hover:text-red-400 px-3"
              aria-label="Remove"
            >
              <X size={14} />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid={`${testIdPrefix}-add`}
          onClick={() => setItems([...items, { name: "", role: "" }])}
          className="inline-flex items-center gap-1.5 text-xs text-blue-400 hover:text-blue-300"
        >
          <Plus size={14} /> Add
        </button>
      </div>
    </div>
  );
}
